import { render, staticRenderFns } from "./key.vue?vue&type=template&id=bd563a3a"
import script from "./key.vue?vue&type=script&lang=js"
export * from "./key.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports